import type { HeroProps } from '@/components/PolicyTwo/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/transparency/transparency_report_og.png';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout, showAskUsAnything: true },
  seo: {
    ...sharedConfig['en-US'].seo,
    title: 'Policy 2.0 by Lemonade Insurance | Lemonade',
    description:
      "Introducing Policy 2.0 by Lemonade: A radically simplified, modernized, and digitized insurance policy. In line with our mantra of transforming insurance from a necessary evil into a social good, we'd love for everyone to contribute to and benefit from the world’s first open source insurance policy.",
    ogImage: og.src,
  },
  hero: {
    title: 'World’s first open source\ninsurance policy',
    subtitle:
      "Policy 2.0 is a radically simplified insurance policy. It's open source, which allows everyone to contribute and benefit from it. Currently only available in Europe.",
    ctaLabel: 'read the policy',
    showGithubLink: true,
  },
};
